import { render, staticRenderFns } from "./OrderReceiverInformation.vue?vue&type=template&id=66a2dc98&scoped=true"
import script from "./OrderReceiverInformation.vue?vue&type=script&lang=js"
export * from "./OrderReceiverInformation.vue?vue&type=script&lang=js"
import style0 from "./OrderReceiverInformation.vue?vue&type=style&index=0&id=66a2dc98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a2dc98",
  null
  
)

export default component.exports